// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DataHolder, DataHolderT, verifyDataHolder } from "./data-holder";

/**
 * A homogeneous or heterogeneous array of values (OPC UA value rank > 0).
 */
export class Array implements flatbuffers.IUnpackableObject<ArrayT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Array {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsArray(bb: flatbuffers.ByteBuffer, obj?: Array): Array {
    return (obj || new Array()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsArray(bb: flatbuffers.ByteBuffer, obj?: Array): Array {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Array()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  elements(index: number, obj?: DataHolder): DataHolder | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new DataHolder()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  elementsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startArray(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addElements(builder: flatbuffers.Builder, elementsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, elementsOffset, 0);
  }

  static createElementsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startElementsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endArray(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // elements
    return offset;
  }

  static createArray(
    builder: flatbuffers.Builder,
    elementsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Array.startArray(builder);
    Array.addElements(builder, elementsOffset);
    return Array.endArray(builder);
  }

  unpack(): ArrayT {
    return new ArrayT(
      this.bb!.createObjList<DataHolder, DataHolderT>(
        this.elements.bind(this),
        this.elementsLength(),
      ),
    );
  }

  unpackTo(_o: ArrayT): void {
    _o.elements = this.bb!.createObjList<DataHolder, DataHolderT>(
      this.elements.bind(this),
      this.elementsLength(),
    );
  }

  unpackFields(...fields: string[]): ArrayT {
    const t = new ArrayT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("elements")) {
      t.elements = this.bb!.createObjList<DataHolder, DataHolderT>(
        this.elements.bind(this),
        this.elementsLength(),
      );
    }
    return t;
  }
}

export class ArrayT implements flatbuffers.IGeneratedObject {
  constructor(public elements: DataHolderT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.elements === null || this.elements === undefined) {
      throw new Error('Required field "elements" is not set');
    }
    const elements = Array.createElementsVector(
      builder,
      builder.createObjectOffsetList(this.elements),
    );

    return Array.createArray(builder, elements);
  }

  clone(): ArrayT {
    const obj = new ArrayT();
    obj.elements = this.elements.map((e) => e.clone());
    return obj;
  }

  equals(other: ArrayT): boolean {
    if (this.elements.length !== other.elements.length) return false;
    for (let i = 0; i < this.elements.length; i++) {
      const a = this.elements[i];
      const b = other.elements[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyArray(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDataHolder);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "elements");
  } finally {
    verifier.popDepth();
  }
}
